import { CustomField, CustomFieldUpdate } from '../types';

export const updateCustomFields = (
  customFields: CustomField[],
  updatedValues: CustomFieldUpdate[]
) => {
  return customFields.map((field) => {
    const updatedField = updatedValues.find(
      (updatedField: CustomFieldUpdate) => updatedField.id === field.id
    );
    return {
      ...field,
      value: updatedField ? updatedField.value : field.value,
    };
  });
};
